/**
 * fetches the public key from the browser.
 *
 * @async
 * @function
 * @name getPublicKey
 * @param {object}
 * @returns {Promise<PublicKeyResponse>} -
 *
 * @author Christian Rojas
 */
import { getXRequestId } from '../utils';
import apiConfig from './apiConfig.ts';

interface Result {
    code: string;
    status: string;
    messages: string[];
}

interface KeyDetails {
    keyid: string;
    pemContent: string;
    keyType: string;
    encryptionAlgorithm: string;
    timeToLive: string;
}

interface PublicKeyResponse {
    result: Result;
    key: KeyDetails;
}

// Builds and returns the headers required for the API request
const buildHeaders = (): Record<string, string> => ({
    'Content-Type': 'application/json',
    'x-fapi-financial-id': '001',
    'x-request-id': getXRequestId(),
    'x-app-cat-id': '88335',
    'x-api-key': apiConfig.connectorGrid.xApiKeyGetEncryptionKey,
});

// Builds and returns the request body in JSON format
const buildRequestBody = (): string =>
    JSON.stringify({
        originatorData: {
            applicationCatalogueId: '88335',
            country: 'CA',
            channel: 'HUB',
        },
        keyAlias: 'alias/SCCG-BMOInternalPubKey',
        resourceName: 'RetrieveIdentificationEvaluation',
    });

// Main function to get the public key from the encryption API
const getPublicKey: (src?: string) => Promise<PublicKeyResponse> = async (src) => {
    try {
        const response = await fetch(src || apiConfig.encryption.getPublicKey, {
            method: 'POST',
            headers: buildHeaders(),
            body: buildRequestBody(),
        });
        if (!response.ok) {
            throw new Error(`Network request for public key failed! Received status code: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.log('fetching to ', apiConfig.encryption.getPublicKey);
        const err = error as Error;
        console.error(`Error in getPublicKey: ${err.message || err}`);
    }
};

export default getPublicKey;
